module.exports = __webpack_public_path__ + "img/Faulty Mechanism.7bbc4001.png";